import Request from './request'
import store from '@/store.js'
// i18n
import i18n from '@/i18n'
// Self-made Snackbar
import snackbar from '@/plugins/snackbar'
// 批次管理
async function fetch(data){
    return Request("get","api/stock-order-analyze/",data)
}

async function fetchOne(id,data){
    return Request("get","api/stock-order-analyze/" + id,data)
}

// 导出出入库明细报表
async function exports(data) {
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/stock-order-analyze/detail-export', data)
    if (response.data && response.data.status.isOK()) {
      snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}
// 导出出入库明细报表江西
async function detailJiangXiExport(data) {
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/stock-order-analyze/detailJiangXiExport', data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

async function chartExports(data) {
  // 出入库统计表导出
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/stock-order-analyze/export', data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

async function materialExport(data) {
  // 出入库统计导出
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/stock-order-analyze/material-export', data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}



export default {
    fetch,
    fetchOne,
    exports,
  chartExports,
  materialExport,
  detailJiangXiExport,
}